// Contact ownership configuration: which partner shell acts for which owner value.
// The shared adapter (src/lib/contactDataAdapter.js) reads this at start-up; it holds no ids itself.
import { GENSERV_PARTNER_ID } from '../lib/genservShell';

export const CONTACT_SCOPE_BY_PARTNER = Object.freeze({
  [GENSERV_PARTNER_ID]: 'genserv',
});

// Child tables the adapter's visits and photos read methods use (config, so the shared lib names no app).
export const CONTACT_CHILD_TABLES = Object.freeze({ visits: 'genserv_visit_work', photos: 'service_job_photos' });
